// Defeat LastPass / browser identity-autofill on fields it would otherwise
// clobber (anything it reads as a name/email/etc. and fills with the VIEWER's
// own info — e.g. the commish player-rename fields).
//
// Proven empirically via the dev autofill probe (/leagues/autofill-probe,
// 2026-06-25): with LastPass on, EVERY attribute opt-out (`data-lpignore` &
// friends), readonly-until-focus, and nonsense `name`/`id` were ignored — the
// only thing that reliably stopped the fill while keeping the real field label
// was `type="search"` (LastPass skips search inputs). Incognito (LastPass off)
// confirmed the culprit is LastPass, not Chrome's native autofill.
//
// Spread `noAutofillProps` onto the input and cn-merge `noAutofillClass` into its
// className. The class strips the WebKit search chrome (rounded corners + the
// clear-"x") so the field renders identically to a normal text input.
//
// Tradeoff to know: a search input clears on Escape and screen readers announce
// it as "search". Acceptable for these admin name fields; revisit if it bites.
export const noAutofillProps = { type: 'search' as const }

export const noAutofillClass =
  'appearance-none [&::-webkit-search-cancel-button]:hidden [&::-webkit-search-decoration]:hidden'
